import React, { useState, useEffect } from 'react';
import api from '../../../Services/api';
import { Chart as ChartJS, ArcElement, Tooltip as ChartTooltip, Legend as ChartLegend, CategoryScale, LinearScale, BarElement } from 'chart.js';
import { Pie, Bar } from 'react-chartjs-2';
import './index.css'
import Snackbar from '@mui/material/Snackbar';
 import { useNavigate, Link } from 'react-router-dom';
import SnackbarContent from '@mui/material/SnackbarContent';
 import { FaBuilding} from 'react-icons/fa';
 
ChartJS.register(ArcElement, ChartTooltip, ChartLegend, CategoryScale, LinearScale, BarElement);
 
const months = [
  { name: "JANUARY", value: "01" },
  { name: "FEBRUARY", value: "02" },
  { name: "MARCH", value: "03" },
  { name: "APRIL", value: "04" },
  { name: "MAY", value: "05" },
  { name: "JUNE", value: "06" },
  { name: "JULY", value: "07" },
  { name: "AUGUST", value: "08" },
  { name: "SEPTEMBER", value: "09" },
  { name: "OCTOBER", value: "10" },
  { name: "NOVEMBER", value: "11" },
  { name: "DECEMBER", value: "12" }
];
 
const AverageMonthlyData = () => {
  let data = sessionStorage.getItem('user');
  let assessorData = JSON.parse(data);
  let assessorId = assessorData.id;
  const currentYear = new Date().getFullYear();
   const navigate = useNavigate();
       const [companyId, setCompanyId] = useState("");
   
  const years = Array.from({ length: currentYear - 2020 + 1 }, (x, i) => 2020 + i);
  const today = new Date();
  const prevMonth = new Date(today.getFullYear(), today.getMonth() - 1);
  const defaultMonth = String(prevMonth.getMonth() + 1).padStart(2, '0'); // '01' to '12'
  
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [avrgData, setAvrgData] = useState('');
  const[vendorList, setVendorList] = useState([]);
  const [monthlyData, setMonthlyData] = useState([]);
  const [nonCompliantList, setNonCompliantList] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(defaultMonth);
  const [vendorAssessd, setVendorAssessd] = useState({});
  const [dataLoaded, setDataLoaded] = useState(false);
  const[inActive,setInacvtive] = useState('')
   const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
    const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
    const[companyData , setCompanyData] = useState({
        principleEmployer: "",
                stateId: "",
                placeName: "",
                pinCode: "",
                authorisedPersonName: "",
                companyEmailId: "",
                companyPhoneNumber: "",
                companyAddress: "",
                authorisedPersonName : "",
                companyEmailId: "",
                companyPhoneNumber:"",
                clientName: "",
                clientContactPersonName: "",
                clientContactPersonPhoneNumber: "",
                clientContactPersonEmailId: "",
                
        
    })

 
  useEffect(() => {
    const Avrg = async () => {
      const response = await api.assessor.dashboard(assessorId, selectedMonth, selectedYear);
      if (response.status === 200) {
        setAvrgData(response.data.averages);
        setMonthlyData(response.data.VendorsMonthlyData);
        setNonCompliantList(response.data.NonCompliedVendorsList);
        setVendorAssessd(response.data.VendorsAssessedList);
        setInacvtive(response.data.Inactive)
        setDataLoaded(true);
      }
      else if(response.status === 404){
        setErrorSnackbarOpen(true)
setSnackbarErrorMessage(response.data.message)
setAvrgData('');
        setMonthlyData([]);
        setNonCompliantList([]);
        setVendorAssessd({});
        setInacvtive('')
      }
      else if(response.status === 400){
        setErrorSnackbarOpen(true)
setSnackbarErrorMessage(response.data.message)
setAvrgData('');
        setMonthlyData([]);
        setNonCompliantList([]);
        setVendorAssessd({});
        setInacvtive('')
      }
      else if(response.status === 500){
        setErrorSnackbarOpen(true)
setSnackbarErrorMessage(response.data.message)
setAvrgData('');
        setMonthlyData([]);
        setNonCompliantList([]);
        setVendorAssessd({});
        setInacvtive('')
      }
    
    };
    Avrg();
  }, [assessorId, selectedMonth, selectedYear]);



  useEffect(() => {
      api.assessor.findOne(assessorId)
      .then(response => {
       
      const temp1 = response.data.data.companyId;
         setCompanyId(temp1); 
      
      })
      .catch(error => console.error('error fetching company data', error));
    },[]);
  
  useEffect(() => {
    if(!companyId) return;
     
  api.client.getClient(companyId).then(response =>{
      const temp2 = response.data;
    
      setCompanyData(temp2);
  })
  },[companyId]);




  const handleBarClick = ({ selectedVendor, selectedMonth, selectedYear }) => {
    navigate('/vendorsmonthlydata', {
      state: {
      selectedVendor,
        month: selectedMonth,
        year: selectedYear,
       
      },
    })
  };

  const handleNonRejected = ({ selectedVendor, selectedMonth, selectedYear }) => {
    console.log(selectedVendor,"id")
    navigate('/vendorsmonthlydata', {
      state: {
      selectedVendor,
        month: selectedMonth,
        year: selectedYear,
      },
    })
    sessionStorage.setItem("validationFilter", 3);

  };


  const handleNonAccepted = ({ selectedVendor, selectedMonth, selectedYear }) => {
    console.log(selectedVendor,"id")
    navigate('/vendorsmonthlydata', {
      state: {
      selectedVendor,
        month: selectedMonth,
        year: selectedYear,
       
      },
    })
    sessionStorage.setItem("validationFilter", 'accepted');

  };
  const handleNonUnderReview = ({ selectedVendor, selectedMonth, selectedYear }) => {
    console.log(selectedVendor,"id")
    navigate('/vendorsmonthlydata', {
      state: {
      selectedVendor,
        month: selectedMonth,
        year: selectedYear,
       
      },
    })
    
    sessionStorage.setItem("validationFilter", 1);
   
  };

  

  useEffect(() => {
    const getAllVendors = async () => {
        const response = await api.vendor.getVendors(assessorId)
        if(response.status === 200) {
              setVendorList(response.data.data)
        }
    }
    getAllVendors()

  },[])


  const getVendorName = (vendorId) => {
    const vendor = vendorList.find(v => v.vendorId === vendorId);
    
    return vendor ? {
      name: vendor.vendorCompanyName,
      state: vendor.vendorStateId || 'N/A'
    } : {
      name: '',
      state: 'N/A'
    };
  
  }
 
  const handleMonthChange = (event) => setSelectedMonth(event.target.value);
  const handleYearChange = (event) => setSelectedYear(event.target.value);
 
  const pieChartData = {
    labels: ['Rejected', 'Under Review', 'Accepted'],
    datasets: [
      {
        data: [Math.round(avrgData?.avgR).toFixed(2) || 0, Math.round(avrgData?.avgUR).toFixed(2)|| 0, Math.round(avrgData?.avgA).toFixed(2) || 0],
        backgroundColor: ['#B22222', '#EFCC00', '#50c878'],
        borderWidth: 0
      }
    ]
  };
 
  const pieOptions = {
    cutout: '30%',
    responsive: true,
    plugins: {
      legend: { display: false, position: 'bottom' },
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem) {
            return `${tooltipItem.raw}%`;
          }
        }
      },
      datalabels: {
        color: 'white',
        align: 'center',
        anchor: 'center',
        font: {
            size: 15,
        },
        formatter: function (value) {
            return value > 0 ? `${value}%` : '';
        },
        position: 'outside',
        offset: 15,  
      }
    }
  };
 
  

 
 
  return (
   
   <>
   <Snackbar
             anchorOrigin={{
               vertical: 'top',
               horizontal: 'right',
             
             }}
             severity="success"
             open={snackbarOpen}
             autoHideDuration={3000}
             onClose={() => setSnackbarOpen(false)}
             sx={{
               marginTop: '2.9%', 
               marginRight: '7%'
             }}
           >
             <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
           </Snackbar>
           <Snackbar
             anchorOrigin={{
               vertical: 'top',
               horizontal: 'right',
             }}
             severity="error"
             open={errorSnackbarOpen}
             autoHideDuration={3000}
             sx={{
               marginTop: '2.9%', 
               marginRight: '7%'
             }}
             onClose={() => {setErrorSnackbarOpen(false)}}
           >
             <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
           </Snackbar>
    
 <div className='mt-4 mx-4'>
  <div className='d-flex justify-content-between'>
           <h1 style={{fontSize:'20px'}}><span className="text-danger">Client : </span>{companyData?.data?.clientName}</h1>
  <div>
 <select className="text-center mx-2 p-1" value={selectedYear || ''} onChange={handleYearChange} style={{cursor: 'pointer', border: '1px solid lightgray' }}>
      <option className="text-dark" value="" disabled>Select Year</option>
      {years.map((year) => (
        <option key={year} value={year}>{year}</option>
      ))}
    </select>
    <select className="text-center text-dark p-1" value={selectedMonth || ''} onChange={handleMonthChange} style={{cursor: 'pointer', border: '1px solid lightgray' }}>
      <option className="text-dark" value="" disabled>Select Month</option>
      {months.map((month) => (
        <option key={month.value} value={month.value}>{month.name}</option>
      ))}
    </select>
    </div>
    </div>
      <div className="mt-4" style={{ display: 'flex', gap: '20px' }}>

    
    
        <div style={{ 
  flex: 1.2, 
  border: '1px solid lightgray', 
  display: 'flex', 
  flexDirection: 'column', 
  justifyContent: 'center', 
  alignItems: 'center' 
}}>
  
  <h3 className="text-center text-light p-3 bg-dark" style={{ width: '100%' }}>
    Month Wise Vendors Average Percentage
  </h3>
  {!avrgData ? (
  <div style={{ 
    height: '250px', 
    width: '250px', 
    margin:'6px',
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center' ,
  }}><h4 className='text-center text-dark'>No Data available for selected month</h4></div>
  ) :
  avrgData.avgA === 0 && avrgData.avgR === 0 && avrgData.avgUR === 0 ?  (
    <div style={{ 
      height: '250px', 
      width: '250px', 
      margin:'6px',
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center' 
    }}>
    <h4 className="text-center text-dark">Uploading Not Started for selected month</h4>
  </div>
  ) : (
<div style={{ 
    height: '250px', 
    width: '250px', 
    margin:'6px',
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center' ,
  }}>
    
    <Pie className='p-4' data={pieChartData} options={pieOptions} />
  </div>
  )}
</div>

 
        {/* Accordion-style Non-compliant List */}
        <div style={{ flex: 2, border: '1px solid lightgray' }}>
  <h3 className="p-3 text-center text-light bg-dark">Non Compliant Vendors List</h3>
  
  <div style={{ height: '250px', overflowY: 'auto' }}>
    <table className="table table-hover nborder-0">
      <thead className="table-light">
        <tr>
          <td className="text-center">Vendor Name</td>
          <td className="text-center">State</td>
          <td className="text-center">Non Compliant</td>
          <td className="text-center">Under Review</td>
        </tr>
      </thead>
      <tbody>
        {nonCompliantList.length === 0 ? (
          <tr>
            <td colSpan="4" className="text-center">No data available for selected month</td>
          </tr>
        ) : (
          nonCompliantList.map((item) => {
            const vendor = getVendorName(item.vendorId);
            return(
            <tr key={item.id}>
              <th className='text-center'>{vendor.name}</th>
              <td className='text-center'>{vendor.state}</td>
              <td className="text-center align-middle">
                <button 
                  className="btn btn-sm btn-danger text-center" 
                  disabled={item.RejectedPercent <= 0 || item.RejectedPercent ==='null'} 
                  style={{cursor:'pointer'}}
                  onClick={() => handleNonRejected({ selectedVendor: item.vendorId, selectedMonth, selectedYear })}
                >
                  {item.RejectedPercent>0 ? `${item.RejectedPercent}`:'0'}%
                </button>
              </td>
              <td className="text-center align-middle">
                <button 
                style={{cursor:'pointer'}}
                 disabled={item.UnderReviewPercent <= 0 || item.UnderReviewPercent ==='null'}
                  className="btn btn-sm btn-secondary" 
                 onClick={() => handleNonUnderReview({ selectedVendor: item.vendorId, selectedMonth, selectedYear })}
                >
                  {item.UnderReviewPercent>0 ? `${item.UnderReviewPercent}`:'0'}%
                </button>
              </td>
            </tr>
            )
})
        )}
      </tbody>
    </table>
  </div>
</div>


<div style={{ flex:0.8}}>
          <h3 className="text-center text-light bg-dark p-2">Assessment Summary</h3>
          <table className="table table-hover" border="0">
          
            <tbody>
  
    <tr>
      <td className="text-center text-dark">Pending</td>
      <td className='text-center text-light bg-danger' ><span style={{fontWeight:'50px'}}>{vendorAssessd.NotAssessed}</span></td>
    </tr>
    <tr>
      <td className="text-center text-dark">In Progress</td>
      <td className='text-center text-light bg-secondary' ><span style={{fontWeight:'50px'}}>{(vendorAssessd.totalVendors) - (vendorAssessd.NotAssessed + vendorAssessd.Assessed)}</span></td>
    </tr>
    <tr>
      <td className="text-center text-dark">Completed</td>
      <td className='text-center text-light bg-success' ><span style={{fontWeight:'50px'}}>{vendorAssessd.Assessed}</span></td>
    </tr>
    <tr>
      <td className="text-center text-dark">Total</td>
      <td className='text-center text-dark bg-light'>{vendorAssessd.totalVendors}</td>
    </tr>
   
 
  </tbody>
          </table>
         <section className="mt-3" style={{border:'1px solid lightgray'}}>
    <div className="w-100 bg-dark text-light text-center p-2">
Inactive Vendor
    </div>
    <h1 className="text-center p-2" style={{fontWeight:'bolder',fontSize:"32px"}}>{inActive.inactive}</h1>
    </section>
        </div>
        {/* Assessed Vendors Table */}
       
      </div>
 
      {/* Second Row: Bar Chart */}
      <div style={{ marginTop: '40px',height:'340px',borderRight:"1px solid lightgray",borderLeft:"1px solid lightgray"}}>
      <h3 className="text-light bg-dark text-center p-3">Vendors Monthly Data</h3>
      {!monthlyData? (
        <div>loading....</div>
      ) : monthlyData.length === 0? (
       <div>
      <h4 className='p-5 text-center text-dark'>No Data available for selected month</h4> 
       </div>
      ):
      monthlyData.every(
        item => item.AcceptedPercent === 0 &&
                item.RejectedPercent === 0 &&
                item.UnderReviewPercent === 0
      ) ? (
      <div>
        <h4 className='p-5 text-center text-dark'>
          Uploading Not Started for selected month
        </h4>
      
      </div>
    ) : 
      
      (
     
        <Bar 
        className="w-100" 
        data={{
                labels: monthlyData.map(item => getVendorName(item.vendorId)?.name?.slice(0,6)),
                datasets: [
                    
                     
                  {
                    label: 'Accepted',
                    backgroundColor: '#3CB371',
                    data: monthlyData.map(item => item.AcceptedPercent || 0),
                    barThickness: 28,
                  },
                  {
                    label: 'Under Review',
                    backgroundColor: '#EFCC00',
                    data: monthlyData.map(item => item.UnderReviewPercent || 0),
                    barThickness: 28,
                  },
                  {
                    label: 'Rejected',
                    backgroundColor: '#B22222',
                    data: monthlyData.map(item => item.RejectedPercent || 0),
                    barThickness: 28,
                  },
                 
                
                ]
              
        }}
           options={{
            responsive: true,
            maintainAspectRatio: false,
            onClick: (event, elements) => {
              if (elements.length > 0) {
                const datasetIndex = elements[0].datasetIndex;
                const index = elements[0].index;
            
                const vendor = monthlyData[index];
                const selectedVendor = vendor?.vendorId;
                const statusLabel = elements[0].element.$context.dataset.label;
            
                const statusMap = {
                  'Accepted': 2,
                  'Under Review': 1,
                  'Rejected': 3,
                };
            
                const selectedStatus = statusMap[statusLabel];
            
              
                sessionStorage.setItem("validationFilter", selectedStatus);

    

            
                handleBarClick({ selectedVendor, selectedMonth, selectedYear });
              }
            },
            onHover: (event, chartElement) => {
              event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
            
            },
            
            scales: {
                x: {
                    stacked: true,
                    grid: {
                        display: false, // Hide grid lines for X-axis
                    },
                    ticks: {
                        display: true,
                        color: 'gray',
                        font: {
                            size: 10,
                        },
                        maxRotation: 45,
                        minRotation: 30,
                    },
                },
                y: {
                    min: 0, // Start the Y-axis from 0%
                    grid: {
                        display: false, // Show grid lines for Y-axis
                    },
                    ticks: {
                        display: false, // Show ticks on Y-axis
                        stepSize: 10, // Control the step size for ticks
                        callback: function (value) {
                            return value + '%'; // Format Y-axis ticks as percentage
                        },
                    },
                    stacked: true,
                },
            },
            plugins: {
                legend: {
                    display: false, // Disable the legend
                },
                title: {
                    display: true,
                },
                tooltip: {
                    callbacks: {
                      label: function (tooltipItem) {
                        const vendorId = monthlyData[tooltipItem.dataIndex]?.vendorId;
                        const vendor = vendorList.find(v => v.vendorId === vendorId);
                  
                        const fullName = vendor?.vendorCompanyName || 'Unknown Vendor';
                        const datasetLabel = tooltipItem.dataset.label || '';
                        const value = tooltipItem.raw;
                  
                        return `${fullName} - ${datasetLabel}: ${value}%`;
                      }
                    }
                  },
               
                datalabels: {
                    display: function (context) {
                        return context.dataset.data[context.dataIndex] !== 0;
                      },
                    color: 'white', // Text color for the percentage labels
                    align: 'center', // Align the label at the center of the bar
                    font: {
                        size: 10, // Font size for the percentage labels
                    },
                    rotation: -50,
                 
                },
            },
        }}
         />
     
      )}
 </div>
      </div>
      </>
  
  );
};
 
export default AverageMonthlyData;